import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';

import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';

interface IDumbFavoriteButtonProps {
  isFavorite: boolean;
  isHeader?: boolean;
  hideText?: boolean;
  buttonTheme?: TButtonTheme;

  onClick?(e: React.MouseEvent): void;
}

export const DumbFavoriteButton = ({
  isFavorite,
  isHeader = false,
  onClick,
  hideText = false,
  buttonTheme,
}: IDumbFavoriteButtonProps) => {
  const buttonText = isFavorite ? 'В избранном' : 'В избранное';
  const iconColor = isFavorite
    ? 'accent-negative-primary'
    : buttonTheme
      ? 'icon-main-default'
      : isHeader
        ? 'icon-primary-default'
        : 'accent-negative-primary';
  const theme = buttonTheme || (isHeader ? 'stroke_secondary' : 'fill_white_primary');

  return (
    <Button
      data-mark={'DumbFavoriteButton'}
      theme={theme}
      size={'M'}
      onClick={onClick}
      beforeIcon={
        isFavorite ? (
          <IconToggleHeartOn16 color={iconColor} data-testid="FavoriteButtonIconOn" />
        ) : (
          <IconToggleHeartOff16 color={iconColor} data-testid="FavoriteButtonIconOff" />
        )
      }
    >
      {hideText ? '' : buttonText}
    </Button>
  );
};
